import { Box } from '@mui/material';
import { keyframes, styled } from '@mui/material/styles';

const sweep = keyframes`
  0%   { content: '▮ ▯ ▯'; }
  33%  { content: '▯ ▮ ▯'; }
  66%  { content: '▯ ▯ ▮'; }
  100% { content: '▮ ▯ ▯'; }
`;

const SpinnerRoot = styled(Box)(({ theme }) => ({
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  height: '100%',
  width: '100%',

  fontFamily: theme.typography.fontFamily,
  fontSize: '0.75rem',
  letterSpacing: '0.2em',

  color: theme.palette.primary.main,
  opacity: 0.75,

  '&::after': {
    content: `'▮ ▯ ▯'`,
    animation: `${sweep} 1s steps(1) infinite`,
  },
}));

export function RetroSpinner() {
  return <SpinnerRoot aria-label="Loading" />;
}
